import styled from 'styled-components';

const Input = styled.input`
	width: 100%;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #979797;
  padding-left: 10px;
  border-radius: 0;
  font-family: Montserrat;
  font-size: 18px;
  color: #333333;
  &:-webkit-autofill{
    background-color: ${props => (props.backgroundColor || props.theme.colors.cremewhite)}!important;
    -webkit-text-fill-color: ${props => (props.backgroundColor || props.theme.colors.darkgrey)};
    -webkit-box-shadow: 0 0 0 1000px ${props => (props.backgroundColor || props.theme.colors.cremewhite)} inset;
  }
  &:focus{
    background-color:inherit !important;
  }
`;

export default Input;
